var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import styled from "styled-components";
import { Query } from "react-apollo";
import { Route, Switch, Redirect } from "react-router-dom";
import gql from "graphql-tag";
import PageNavigation from "components/shared/Page/PageNavigation";
import PageBoard from "./PageBoard";
import Subpage from "components/shared/Page/SubPage";
import Loading from "components/shared/Loading";
import Error from "components/shared/Error";
import SubMenu from "./SubMenu";
var RootDiv = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
var GET_PAGE = gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  query GetPage($projectName: String!, $pageName: String!) {\n    page(projectName: $projectName, pageName: $pageName) {\n      subpages {\n        id\n        name\n        urlName\n      }\n      boards {\n        id\n        name\n        urlName\n      }\n      submenus {\n        id\n        name\n        urlName\n      }\n    }\n  }\n"], ["\n  query GetPage($projectName: String!, $pageName: String!) {\n    page(projectName: $projectName, pageName: $pageName) {\n      subpages {\n        id\n        name\n        urlName\n      }\n      boards {\n        id\n        name\n        urlName\n      }\n      submenus {\n        id\n        name\n        urlName\n      }\n    }\n  }\n"])));
export default (function (_a) {
    var project = _a.project, name = _a.name, match = _a.match;
    return (React.createElement(Query, { query: GET_PAGE, variables: { projectName: project, pageName: name } }, function (_a) {
        var loading = _a.loading, error = _a.error, data = _a.data;
        if (loading)
            return React.createElement(Loading, null);
        if (error)
            return React.createElement(Error, null);
        var _b = data.page, subpages = _b.subpages, boards = _b.boards, submenus = _b.submenus;
        return (subpages || boards || submenus) &&
            (subpages.length || boards.length || submenus.length) ? (React.createElement(RootDiv, null,
            React.createElement(PageNavigation, __assign({}, data.page, { match: match })),
            React.createElement("div", { className: "content" },
                React.createElement(Switch, null,
                    React.createElement(Redirect, { from: match.url, exact: true, to: match.url + "/" + (subpages[0] || boards[0] || submenus[0]).urlName }),
                    subpages.map(function (subpage, idx) { return (React.createElement(Route, { key: idx, path: match.url + "/" + subpage.urlName, render: function (props) { return React.createElement(Subpage, { id: subpage.id }); } })); }),
                    boards.map(function (board, idx) { return (React.createElement(Route, { key: idx, path: match.url + "/" + board.urlName, render: function (props) { return React.createElement(PageBoard, __assign({ id: board.id }, props)); } })); }),
                    submenus.map(function (submenu, idx) { return (React.createElement(Route, { key: idx, path: match.url + "/" + submenu.urlName, render: function (props) { return React.createElement(SubMenu, __assign({ id: submenu.id }, props)); } })); }),
                    React.createElement(Route, { component: Error }))))) : null;
    }));
});
var templateObject_1, templateObject_2;
